// src/services/AuthService.js
import axios from 'axios';

const AuthService = {
  login(username, password) {
    return axios.post('etherscan/login.php', { username, password })
      .then(response => {
        if (response.data.status === 'success') {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('username', username); // Explicitly store username

          return true;
        } else {
      //    console.log('AuthService login: Login failed');
          return false;
        }
      })
      .catch(error => {
       console.error('AuthService login: Error occurred during login:', error);
        return false;
      });
  },
  logout() {

  localStorage.removeItem('token');
  localStorage.removeItem('username');
  localStorage.removeItem('role');                 // add
  localStorage.removeItem('can_use_normal_mode');  // add
  },
  getRole() {
    return localStorage.getItem('role') || null;
  },
  canUseNormalMode() {
    return localStorage.getItem('can_use_normal_mode') === 'yes';
  },
  isAuthenticated() {
    const token = localStorage.getItem('token');
    if (token) {
      return axios.post('etherscan/verify.php', { token })
        .then(response => {
         // console.log('[AuthService] Verify response:', response.data); // DEBUG
          return response.data.status === 'success';
        })
        .catch(() => {
       // .catch((err) => {
        //  console.error('[AuthService] Verify error:', err);
          return false;
        });
    }
    return Promise.resolve(false);
  }
,  

/*
  getUserRole() {
    const token = localStorage.getItem('token');
    if (token) {
      return axios.post('etherscan/verify.php', { token })
        .then(response => {
          if (response.data.status === 'success') {
            const roleInfo = {
              role: response.data.data.role,
              canUseNormalMode: response.data.data.can_use_normal_mode || false
            };
             // console.log("getUserRole roleInfo:", roleInfo); // Logging for confirmation
            return roleInfo;
          } else {
            return { role: null, canUseNormalMode: false };
          }
        })
        .catch((error) => {
          console.error("getUserRole error:", error);
          return { role: null, canUseNormalMode: false };
        });
    }
    return Promise.resolve({ role: null, canUseNormalMode: false });
  }
  
  ,*/
  getUserRole() {
  const token = localStorage.getItem('token');
  if (!token) return Promise.resolve({ role: null, canUseNormalMode: false, isRestricted: false });

  return axios.post('etherscan/verify.php', { token })
    .then(response => {
      if (response.data.status === 'success') {
        return {
          role: response.data.data.role,
          canUseNormalMode: !!response.data.data.can_use_normal_mode,
          isRestricted: !!response.data.data.is_restricted,
          restrictionReason: response.data.data.restriction_reason || '',
          restrictionUntil: response.data.data.restriction_until || null,
        };
      }
      return { role: null, canUseNormalMode: false, isRestricted: false };
    })
    .catch(() => ({ role: null, canUseNormalMode: false, isRestricted: false }));
}
,
  getUsername() {
    return localStorage.getItem('username') || null; // Retrieve username directly from localStorage
  }
};

export default AuthService;
